// extracted by mini-css-extract-plugin
export default {"header":"_1xHVr","backButton":"_3hFR8","searchInputContainer":"_1gFYV","input":"_2v1LT","icon":"_21g73"};